export const ServiceLevelsKpisActionTypes = {
    API_RESPONSE_SUCCESS: '@@service-levels-kpis/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@service-levels-kpis/API_RESPONSE_ERROR',
    GET_SHIPMENTS_SERVICE_LEVELS_REQUEST: '@@service-levels-kpis/GET_SHIPMENTS_SERVICE_LEVELS_REQUEST',
    GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST: '@@service-levels-kpis/GET_SHIPMENTS_DAY_SERVICE_LEVELS_REQUEST',
    GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST: '@@service-levels-kpis/GET_SHIPMENTS_SERVICE_LEVELS_BY_TIMEFRAME_REQUEST',
    GET_SHIPMENTS_AGGREGATED_COST_REQUEST: '@@service-levels-kpis/GET_SHIPMENTS_AGGREGATED_COST_REQUEST',
};
